import {
  authStore,
  useIsAuthenticated,
  useIsAdmin,
  useIsBootBlocked,
  useFullName,
} from '@/lib/auth-store';
import { login, logout, retryBoot } from '@/lib/auth-service';

/**
 * The auth facade — the single seam admin reads auth through. Backed by the
 * TanStack-Store auth session (auth-store.ts) + its actions (auth-service.ts),
 * replacing the old Pinia useAuthStore.
 *
 * Reactive members are LIVE selectors (Refs). DESTRUCTURE them at the top of a
 * <script setup> so the template auto-unwraps them — a nested auth.foo ref is NOT
 * auto-unwrapped in templates.
 */
export function useAuth() {
  return {
    // Reactive state (live selectors over the auth-store's reactive state)
    user: authStore.useSelector((s) => s.user),
    session: authStore.useSelector((s) => s.session),
    isLoading: authStore.useSelector((s) => s.isLoading),
    isInitializing: authStore.useSelector((s) => s.isInitializing),
    error: authStore.useSelector((s) => s.error),
    bootAttempt: authStore.useSelector((s) => s.bootAttempt),
    bootFailed: authStore.useSelector((s) => s.bootFailed),
    isAuthenticated: useIsAuthenticated(),
    isAdmin: useIsAdmin(),
    isBootBlocked: useIsBootBlocked(),
    fullName: useFullName(),

    // Actions
    login,
    logout,
    retryBoot,
  } as const;
}
